import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function phoneNumberValidator(countryCodes: any[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const countryCode = control.get('country_code')?.value;
    const mobileNumber = control.get('mobile_number')?.value;

    if (!countryCode || !mobileNumber) {
      return null; // Let required validator handle empty fields
    }

    const country = countryCodes.find(c => c.dial_code === countryCode);
    if (!country) {
      return { invalidCountryCode: true };
    }

    const phoneLength = country.phoneLength;
    const numberLength = mobileNumber.replace(/\D/g, '').length;

    if (Array.isArray(phoneLength)) {
      if (!phoneLength.includes(numberLength)) {
        return { invalidPhoneLength: true };
      }
    } else {
      if (numberLength !== phoneLength) {
        return { invalidPhoneLength: true };
      }
    }

    return null;
  };
}